import { render, staticRenderFns } from "./loader1.vue?vue&type=template&id=7e480f2d&"
import script from "./loader1.vue?vue&type=script&lang=js&"
export * from "./loader1.vue?vue&type=script&lang=js&"
import style0 from "./loader1.vue?vue&type=style&index=0&id=7e480f2d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports